<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-xl-4 order-xl-2 mb-5 mb-xl-0">

                    <div class="card card-profile shadow">
                        <div class="row justify-content-center">
                            <div class="col-lg-3 order-lg-2">
                                <div class="card-profile-image">
                                        <!-- <img src="/img/noimage.png" class="rounded-circle"> -->
                                        <img style="max-width:250px" v-if="form.photo === ''" src="/img/noimage.png">
                                        <img style="max-width:250px" v-if="form.photo !== ''" :src="form.photo.thumbnail">
                                </div>
                            </div>
                        </div>
                        <div class="card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">
                            <div class="d-flex justify-content-between">
                                <!-- <base-button size="sm" type="info" class="mr-4">Connect</base-button>
                                <base-button size="sm" type="default" class="float-right">Message</base-button> -->
                            </div>
                        </div>
                        <div class="card-body pt-0 pt-md-4">
                            <div class="row">
                                <div class="col">
                                    <div class="card-profile-stats d-flex justify-content-center mt-md-5" style="margin-bottom:50px">
                                        <!-- <div>
                                            <span class="heading">22</span>
                                            <span class="description">Friends</span>
                                        </div>
                                        <div>
                                            <span class="heading">10</span>
                                            <span class="description">Photos</span>
                                        </div>
                                        <div>
                                            <span class="heading">89</span>
                                            <span class="description">Comments</span>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                            <div class="text-center">
                                <div style="margin-bottom:50px">
                                    <base-button @click="Delete('ImgProfile')" v-if="form.photo !== ''" type="danger">{{$t('delete_image')}}</base-button><br /><br />
                                    <div class="custom-file">
                                        <input type="file" accept="image/*" name="profile_img" id="profile_img" ref="profile_img" v-on:change="onFileChanged()" class="custom-file-input">
                                        <label class="custom-file-label" for="profile_img">{{$t('change_image')}}</label>
                                    </div>
                                </div>
                                <h3>
                                    {{$t('status')}} : 
                                    <span v-if="form.status === 'new'" class="font-weight-light">{{$t('new')}}</span>
                                    <span v-if="form.status === 'active'" class="font-weight-light">{{$t('active')}}</span>
                                    <span v-if="form.status === 'disabled'" class="font-weight-light">{{$t('disabled')}}</span>
                                    <span v-if="form.status === 'expired'" class="font-weight-light">{{$t('expired')}}</span>
                                </h3>
                                <!-- <div class="h5 font-weight-300">
                                    <i class="ni location_pin mr-2"></i>Bucharest, Romania
                                </div> -->
                                <div class="h5 mt-4">
                                    {{$t('createdAt')}} : {{ form.created_at | luxon }} <br />
                                    {{$t('expired_at')}} : {{ form.expired_at | luxon }}
                                </div>
                                <hr class="my-4" />
                                <h3>
                                    {{$t('sessions')}}
                                </h3>
                                <!-- <div class="h5 font-weight-300">
                                    <i class="ni location_pin mr-2"></i>Bucharest, Romania
                                </div> -->
                                <div class="h5 mt-4">
                                    <div style="margin-bottom:20px" v-for="item in sessions" :key="item._id">{{item.info}}<br />
                                    ใช้งานล่าสุด : {{item.last_seen | luxon}}<br />
                                    <base-button v-if="item.is_current === false" style="margin:5px" @click="del_session(item._id)" size="sm" type="danger">{{$t('logout')}}</base-button>
                                    <base-button v-if="item.is_current === true" disabled style="margin:5px" size="sm" type="secondary">{{$t('logout')}}</base-button>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <div>
                                    <base-button style="margin:5px" type="primary" @click="Renew()">{{$t('renew')}}</base-button>
                                    <base-button style="margin:5px" @click="ChangePasswordConfirm()" type="warning">{{$t('change_password')}}</base-button>
                                </div>
                                <hr class="my-4" />
                                <div>
                                    <base-button @click="Delete('Profile')" type="danger">{{$t('delete_profile')}}</base-button>
                                </div>

                                <!-- <hr class="my-4" />
                                <p>Ryan — the name taken by Melbourne-raised, Brooklyn-based Nick Murphy — writes, performs and records all of his own music.</p>
                                <a href="#">Show more</a> -->
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xl-8 order-xl-1">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">{{$t('profile')}}</h3>
                                </div>
                                <div class="col-4 text-right">
                                    <!-- <a href="#!" class="btn btn-sm btn-primary">Settings</a> -->
                                </div>
                            </div>
                        </div>
                        <template>
                            <ValidationObserver v-slot="{ passes }">
                            <form @submit.prevent="passes(onSubmit)">
                                <h6 class="heading-small text-muted mb-4">{{$t('user_information')}}</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input :name="$t('first_name')" class="input-group-alternative mb-3"
                                                        required
                                                        :label="$t('first_name')"
                                                        rules="required"
                                                        :placeholder="$t('first_name')"
                                                        v-model="form.firstname">
                                            </base-input>
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input :name="$t('last_name')" class="input-group-alternative mb-3"
                                                        required
                                                        :label="$t('last_name')"
                                                        rules="required"
                                                        :placeholder="$t('last_name')"
                                                        v-model="form.lastname">
                                            </base-input>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input :name="$t('phone')" class="input-group-alternative mb-3"
                                                        required
                                                        :label="$t('phone')"
                                                        rules="required|min:9"
                                                        :placeholder="$t('phone')"
                                                        v-model="form.phone">
                                            </base-input>
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input :name="$t('email')" class="input-group-alternative mb-3"
                                                        required
                                                        :label="$t('email')"
                                                        rules="required|email"
                                                        :placeholder="$t('email')"
                                                        v-model="form.email">
                                            </base-input>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6">

                                            {{$t('gender')}} <span style="color:red">*</span><br /><br />

                                            <base-radio name="male" class="mb-3" v-model="form.gender">
                                                {{$t('male')}}
                                            </base-radio>

                                            <base-radio name="female" class="mb-3" v-model="form.gender">
                                                {{$t('female')}}
                                            </base-radio>
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <!-- Address -->
                                <h6 class="heading-small text-muted mb-4">{{$t('contact_information')}}</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <base-input :name="$t('address')" class="input-group-alternative mb-3"
                                                        required
                                                        :label="$t('address')"
                                                        rules="required|min:4"
                                                        :placeholder="$t('address')"
                                                        v-model="form.address">
                                            </base-input>
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <div class="text-right">
                                    <base-button nativeType="submit" type="primary" class="my-4">{{$t('save')}}</base-button>
                                </div>
                            </form>
                        </ValidationObserver>
                        </template>
                    </card>
                </div>
            </div>
        </div>

        <modal :show.sync="modal_confirm">

            <p>{{$t('confirm_delete')}}</p>

            <template slot="footer">
                <base-button @click="modal_confirm = false" type="primary">{{$t('cancel')}}</base-button>
                <base-button v-if="type_delete === 'Profile'" @click="DeleteProfileConfirm()" type="danger">{{$t('delete')}}</base-button>
                <base-button v-if="type_delete === 'ImgProfile'" @click="DeleteImgProfile()" type="danger">{{$t('delete')}}</base-button>
            </template>

        </modal>

        <modal :show.sync="modal_form"
               body-classes="p-0"
               modal-classes="modal-dialog-centered modal-sm">
            <card type="secondary" shadow
                  header-classes="bg-white pb-5"
                  body-classes="px-lg-5 py-lg-5"
                  class="border-0">
                <template>
                        <ValidationObserver v-slot="{ passes }">
                        <form @submit.prevent="passes(DeleteProfile)">
                            <base-input :name="$t('password')" class="input-group-alternative"
                                        :placeholder="$t('password')"
                                        :label="$t('password')"
                                        required
                                        rules="required|min:6"
                                        type="password"
                                        v-model="form.password">
                            </base-input>
                            <div class="text-right">
                                <base-button @click="modal_form = false" type="primary">{{$t('cancel')}}</base-button>
                                <base-button nativeType="submit" type="primary" class="my-4">{{$t('delete')}}</base-button>
                            </div>
                        </form>
                        </ValidationObserver>
                </template>
            </card>
        </modal>

        <modal :show.sync="modal_form_changepass"
               body-classes="p-0"
               modal-classes="modal-dialog-centered modal-sm">
            <card type="secondary" shadow
                  header-classes="bg-white pb-5"
                  body-classes="px-lg-5 py-lg-5"
                  class="border-0">
                <template>
                        <ValidationObserver v-slot="{ passes }">
                        <form @submit.prevent="passes(ChangePassword)">
                            <base-input :name="$t('old_password')" class="input-group-alternative"
                                        :placeholder="$t('old_password')"
                                        :label="$t('old_password')"
                                        required
                                        rules="required|min:6"
                                        type="password"
                                        addon-right-icon="display-eye fa fa-eye"
                                        v-model="form.old_password">
                            </base-input>
                            <base-input :name="$t('new_password')" class="input-group-alternative"
                                        :placeholder="$t('new_password')"
                                        :label="$t('new_password')"
                                        required
                                        rules="required|min:6"
                                        type="password"
                                        addon-right-icon="display-eye fa fa-eye"
                                        v-model="form.new_password">
                            </base-input>
                            <div class="text-right">
                                <base-button @click="modal_form_changepass = false" type="primary">{{$t('cancel')}}</base-button>
                                <base-button nativeType="submit" type="primary" class="my-4">{{$t('change_password')}}</base-button>
                            </div>
                        </form>
                        </ValidationObserver>
                </template>
            </card>
        </modal>

        <modal :show.sync="modal_success">

            <p>{{$t('confirm_success')}}</p>

            <template slot="footer">
                <base-button @click="modal_success = false" type="primary">{{$t('close')}}</base-button>
            </template>

        </modal>

        <modal :show.sync="modal"
                :gradient="modal_setting.gradient"
                modal-classes="modal-danger modal-dialog-centered">
                <div class="py-3 text-center">
                    <i class="ni ni-bell-55 ni-3x"></i>
                    <h4 class="heading mt-4"></h4>
                    <p>{{modal_setting.alert_text}}</p>
                </div>

                <template slot="footer">
                    <base-button type="link"
                                text-color="white"
                                class="ml-auto"
                                @click="modal = false">
                        {{$t('close')}}
                    </base-button>
                </template>
            </modal>
    </div>
</template>
<script>
import { ValidationObserver } from "vee-validate"
import i18n from "@/i18n"
  export default {
    name: 'profile',
    components: {
        ValidationObserver
    },
    data() {
      return {
        modal: false,
        modal_setting: {
            alert_text: '',
            gradient: ''
        },
        modal_confirm: false,
        modal_form: false,
        modal_form_changepass: false,
        modal_success: false,
        type_delete: '',
        profile_img_file: '',
        sessions: '',
        form: {
          phone: '',
          email: '',
          firstname: '',
          lastname: '',
          address: '',
          gender: '',
          photo: '',
          password: '',
          old_password: '',
          new_password: ''
        }
      }
    },
    created () {
      this.ListItem()
      this.ListSessions()
    },
    methods: {
        modalAlert (req) {
            if(req) {
                this.modal_setting.alert_text = req.data.message
            } else {
                this.modal_setting.alert_text = "ERROR"
            }
            this.modal_setting.gradient = "danger"
            this.modal = true
        },
        del_session (id) {
            this.$http.delete('sessions/'+id)
            .then(request => this.del_sessionSuccessful(request))
            .catch(() => this.del_sessionFailed())
        },
        del_sessionSuccessful (req) {
            if (req.data.code !== '0') {
                this.del_sessionFailed(req)
                return
            }
            this.ListSessions()
        },
        del_sessionFailed (req) {
            this.modalAlert(req)
        },
        Delete (type) {
            this.modal_confirm = true
            this.type_delete = type
        },
        onFileChanged () {
            this.profile_img_file = this.$refs.profile_img.files[0]
            this.submitFile()
        },
        submitFile () {
            let formData = new FormData()
            formData.append('file', this.profile_img_file)
            this.$http.post('profile/image',
            formData)
            .then(request => this.AddImageSuccessful(request))
            .catch()
        },
        AddImageSuccessful () {
            this.ListItem()
        },
        ListItem () {
            this.$http.get('profile')
            .then(request => this.ListItemSuccessful(request))
            .catch(() => this.ListItemFailed())
        },
        ListItemSuccessful (req) {
            if (req.data.code !== '0') {
                this.ListItemFailed(req)
                return
            }
            this.form = req.data.data
            if(req.data.data.photo === undefined) {
                this.form.photo = ''
            }
        },
        ListItemFailed (req) {
            this.modalAlert(req)
        },
        ListSessions () {
            this.$http.get('sessions')
            .then(request => this.ListSessionsSuccessful(request))
            .catch(() => this.ListSessionsFailed())
        },
        ListSessionsSuccessful (req) {
            if (req.data.code !== '0') {
                this.ListSessionsFailed(req)
                return
            }
            this.sessions = req.data.data
        },
        ListSessionsFailed (req) {
            this.modalAlert(req)
        },
        onSubmit () {
            this.$http.patch('profile', {
                "email": this.form.email,
                "phone": this.form.phone,
                "firstname": this.form.firstname,
                "lastname": this.form.lastname,
                "address": this.form.address,
                "gender": this.form.gender
            })
                .then(request => this.onSubmitSuccessful(request))
                .catch(() => this.onSubmitFailed())
        },
        onSubmitSuccessful (req) {
            if (req.data.code !== '0') {
                this.onSubmitFailed(req)
                return
            }
            this.modal_success = true
            this.ListItem()
        },
        onSubmitFailed (req) {
            this.modalAlert(req)
        },
        ChangePasswordConfirm () {
            this.modal_form_changepass = true
        },
        ChangePassword () {
            this.modal_form_changepass = false
            this.$http.post('profile/password', {
                "old_password": this.form.old_password,
                "new_password": this.form.new_password
            })
                .then(request => this.ChangePasswordSuccessful(request))
                .catch(() => this.ChangePasswordFailed())
        },
        ChangePasswordSuccessful (req) {
            if (req.data.code !== '0') {
                this.ChangePasswordFailed(req)
                return
            }
            this.modal_success = true
            this.ListItem()
        },
        ChangePasswordFailed (req) {
            this.modalAlert(req)
        },
        Renew () {
            this.$http.post('profile/renew')
                .then(request => this.RenewSuccessful(request))
                .catch(() => this.RenewFailed())
        },
        RenewSuccessful (req) {
            if (req.data.code !== '0') {
                this.RenewFailed(req)
                return
            }
            this.modal_success = true
            this.ListItem()
        },
        RenewFailed (req) {
            this.modalAlert(req)
        },
        DeleteProfileConfirm () {
            this.modal_confirm = false
            this.modal_form = true
            // this.DeleteProfile()
        },
        DeleteProfile () {
            this.modal_form = false
            this.$http.post('/profile/delete', {
                "password": this.form.password
            })
            .then(request => this.DeleteProfileSuccessful(request))
            .catch(() => this.DeleteProfileFailed())
        },
        DeleteProfileSuccessful (req) {
            if (req.data.code !== '0') {
            this.DeleteProfileFailed(req)
            return
            }
            this.$router.replace(this.$route.query.redirect || '/'+i18n.locale+'/logout')
        },
        DeleteProfileFailed (req) {
            this.modalAlert(req)
        },
        DeleteImgProfile () {
            this.modal_confirm = false
            this.$http.delete('profile/image')
            .then(request => this.DeleteImgProfileSuccessful(request))
            .catch(() => this.DeleteImgProfileFailed())
        },
        DeleteImgProfileSuccessful (req) {
            if (req.data.code !== '0') {
            this.DeleteImgProfileFailed(req)
            return
            }
            this.form.photo = ''
        },
        DeleteImgProfileFailed (req) {
            this.modalAlert(req)
        }
    }
  };
</script>
<style></style>
